import React from "react";
import { Settings, BarChart3 } from "lucide-react";
import SearchInput from "./SearchInput";
import MetaFilterDropdown from "./MetaFilterDropdown";
import DatePicker from "./DatePicker";
import ActionButtons from "./ActionButtons";
import { getCardStyle } from "../../styles/attendanceStyles";

const FiltersPanel = ({
  theme,
  isRTL,
  t,
  language,
  searchTerm,
  setSearchTerm,
  workingCompanyOptions = [],
  filterWorkingCompany,
  setFilterWorkingCompany,
  companySearch,
  setCompanySearch,
  departmentOptions = [],
  filterDepartment,
  setFilterDepartment,
  departmentSearch,
  setDepartmentSearch,
  selectedDate,
  setSelectedDate,
  filteredAttendance,
  attendanceData,
  totalEmployees = 0,
  isRecalculating,
  canRefreshAttendance,
  canExportCsv,
  canExportTemplate,
  canImportCsv,
  canImportLocationSchedule,
  canDefaultLocation,
  canScheduleTemplate,
  canApproveOvertime,
  overtimeApprovalRequired,
  forceRefreshAttendance,
  exportToCSV,
  handleImportFileChange,
  // ── Overtime indicator props ──────────────────────────────────────────
  overtimePendingCount = 0,
  overtimeTotalCount = 0,
  onOvertimeClick,
}) => {
  return (
    <div style={getCardStyle(theme)}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "16px",
          flexDirection: isRTL ? "row" : "row",
        }}
      >
        <div>
          <h3
            style={{
              fontSize: "clamp(16px, 3vw, 20px)",
              fontWeight: "700",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexDirection: isRTL ? "row" : "row",
            }}
          >
            <Settings size={20} />
            {t.filtersActions}
          </h3>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            flexWrap: "wrap",
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              color: theme === "dark" ? "rgba(255,255,255,0.7)" : "#6b7280",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              flexDirection: isRTL ? "row" : "row",
            }}
          >
            <BarChart3 size={16} />
            {t.showing} {filteredAttendance.length} {t.of}{" "}
            {totalEmployees || attendanceData.length} {t.records}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        <SearchInput
          theme={theme}
          isRTL={isRTL}
          t={t}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          attendanceData={attendanceData}
        />
        <DatePicker
          theme={theme}
          isRTL={isRTL}
          t={t}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
        <MetaFilterDropdown
          theme={theme}
          isRTL={isRTL}
          language={language}
          label={t.workingCompany || (language === "ar" ? "الشركة" : "Working Company")}
          allLabel={t.allCompanies || (language === "ar" ? "كل الشركات" : "All Companies")}
          options={workingCompanyOptions}
          value={filterWorkingCompany}
          setValue={setFilterWorkingCompany}
          search={companySearch}
          setSearch={setCompanySearch}
        />
        <MetaFilterDropdown
          theme={theme}
          isRTL={isRTL}
          language={language}
          label={t.department || (language === "ar" ? "القسم" : "Department")}
          allLabel={t.allDepartments || (language === "ar" ? "كل الأقسام" : "All Departments")}
          options={departmentOptions}
          value={filterDepartment}
          setValue={setFilterDepartment}
          search={departmentSearch}
          setSearch={setDepartmentSearch}
        />
      </div>

      <ActionButtons
        theme={theme}
        isRTL={isRTL}
        t={t}
        language={language}
        isRecalculating={isRecalculating}
        canRefreshAttendance={canRefreshAttendance}
        canExportCsv={canExportCsv}
        canExportTemplate={canExportTemplate}
        canImportCsv={canImportCsv}
        canImportLocationSchedule={canImportLocationSchedule}
        canDefaultLocation={canDefaultLocation}
        canScheduleTemplate={canScheduleTemplate}
        canApproveOvertime={canApproveOvertime}
        overtimeApprovalRequired={overtimeApprovalRequired}
        forceRefreshAttendance={forceRefreshAttendance}
        exportToCSV={exportToCSV}
        handleImportFileChange={handleImportFileChange}
        overtimePendingCount={overtimePendingCount}
        overtimeTotalCount={overtimeTotalCount}
        onOvertimeClick={onOvertimeClick}
      />
    </div>
  );
};

export default FiltersPanel;

